import { render } from "./GuardianSelectionModal.vue?vue&type=template&id=c4b78136&scoped=true"
import script from "./GuardianSelectionModal.vue?vue&type=script&lang=js"
export * from "./GuardianSelectionModal.vue?vue&type=script&lang=js"

import "./GuardianSelectionModal.vue?vue&type=style&index=0&id=c4b78136&lang=css"
import "./GuardianSelectionModal.vue?vue&type=style&index=1&id=c4b78136&scoped=true&lang=css"

import exportComponent from "../../../../../irap-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4b78136"]])

export default __exports__